<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{ pageTitle }}</h3>
            <div class="box-tools pull-right">
              <page-add @finish="finish">新加</page-add>
            </div>
          </div>
          <div class="box-body">

            <el-card class="box-card" shadow="never">
              <div class="query">
                <el-form :inline="true">
                  <el-form-item label="搜索">
                    <el-input v-model="query.keyword" clearable placeholder="输入名称搜索"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :disabled="loading" @click="querySearch">查询</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <el-table :data="list" border style="width: 100%" v-loading="loading">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="mobile" label="手机"></el-table-column>
                <el-table-column prop="account" label="登录账号"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items: center;">
                      <page-edit :param="scope.row" @finish="finish">
                        编辑
                      </page-edit>
                      <page-delete :param="scope.row" @finish="finish">
                        删除
                      </page-delete>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div v-if="list.length > 0">
                <div style="height: 20px;"></div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :current-page="query.page"
                    :page-size="query.size"
                    :total="total"
                    @current-change="pageSelect"
                >
                </el-pagination>
              </div>

            </el-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapState} from "vuex";

import PageAdd from "@/views/system/user/Add.vue";
import PageEdit from "@/views/system/user/Edit.vue";
import PageDelete from "@/views/system/user/Delete.vue";

export default {
  components: {
    PageDelete,
    PageAdd,
    PageEdit
  },
  data() {
    return {
      loading: false,
      query: {
        keyword: '',
        page: 1,
        size: 10
      },
      list: [],
      total: 0,
      canNext: false,
      nextPage: 1,
      typeList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
    pageTitle: (state) => state.pageTitle,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query)
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then(() => {
          _this.loadList();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
    querySearch() {
      const _this = this;
      _this.query.page = 1;
      _this.loading = true;
      _this.loadList();
    },
    pageSelect(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.loading = true;
      _this.loadList();
    },
    loadList() {
      const _this = this;
      _this.$apiAdmin.adminPeopleList(_this.query)
          .then(res => {
            _this.loading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.canNext = res.can_next;
            _this.nextPage = res.next_page;
            _this.updateUrl();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    finish() {
      const _this = this;
      _this.loadList();
    }
  }
}
</script>


<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>